import React from "react"
import { graphql } from "gatsby"

import { SEO } from "@components/SEO/SEO"
import Hero from "@components/Hero/Hero"
import Layout from "@components/Layout/Layout"

function DEEnqueteSatisfaction({ data }) {
  return (
    <div>
      <Layout lang="de">
        <Hero
          title="Zufriedenheitsumfrage"
          backgroundHero={data.hero.childImageSharp.gatsbyImageData}
        ></Hero>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <iframe
            title="Zufriedenheitsumfrage"
            src="https://docs.google.com/forms/d/e/1FAIpQLSe5e9ZE6LKKq-XZib0GMbt2Fg5xLG2WWyLh144OBo-bx1_JBA/viewform?embedded=true"
            width="100%"
            height="2000"
            frameborder="0"
            marginwidth="0"
            marginheight="0"
          >
            Loading...
          </iframe>
        </div>
      </Layout>
    </div>
  )
}

export default DEEnqueteSatisfaction

export const query = graphql`
  {
    hero: file(name: { eq: "ouvrier-sur-chantier-FEHR-Group" }) {
      childImageSharp {
        gatsbyImageData(placeholder: DOMINANT_COLOR, layout: FULL_WIDTH)
      }
    }
  }
`

export const Head = ({ location, params, data, pageContext }) => {
  return (
    <SEO
      title="Zufriedenheitsumfrage | FEHR"
      description="Sie haben Fehr Produkte für Ihre Baustelle ausgewählt …
      Ihre Meinung interessiert uns !"
      pathname={location.pathname}
    />
  )
}
